import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { msalInstance, apiTokenRequest, loginRequest } from './msalConfig'

/**
 * Acquire the API access token (the one the backend validates as Bearer).
 * Returns null when B2C is disabled (mock/dev) or no account is signed in.
 * On interaction-required, kicks off a redirect to re-auth and returns null.
 * Imported by the Apollo auth link via the singleton, independent of React.
 */
export async function acquireApiToken(): Promise<string | null> {
  if (!msalInstance) return null
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0]
  if (!account) return null
  try {
    const result = await msalInstance.acquireTokenSilent({ ...apiTokenRequest, account })
    return result.accessToken
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      await msalInstance.acquireTokenRedirect({ ...loginRequest, account })
    }
    return null
  }
}
